module.exports = __webpack_public_path__ + "static/media/tab.3e3099d5.png";